import React from 'react';
import { useTranslation } from 'react-i18next';

const DobSelect = ({ slideCode, slideValues, groupComps, handleValueChange }) => {
  const { t } = useTranslation();

  const dobGroup = groupComps.find((g) => g.name === 'gDob');
  const dayComp = dobGroup?.controls?.find((c) => c.name === 'day');
  const monthComp = dobGroup?.controls?.find((c) => c.name === 'month');
  const yearComp = dobGroup?.controls?.find((c) => c.name === 'year');

  const dayVal = slideValues[slideCode]?.day?.value ?? '';
  const monthVal = slideValues[slideCode]?.month?.value ?? '';
  const yearVal = slideValues[slideCode]?.year?.value ?? '';

  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = currentYear; y >= 1927; y--) years.push(y);

  return (
    <div className="t-mt-2">
      <div className="t-flex t-gap-2.5 t-text-[11px] t-font-semibold t-text-g500 t-mb-1.5 t-uppercase">
        <span className="t-flex-1">{t('DAY')}</span>
        <span className="t-flex-1">{t('MONTH')}</span>
        <span className="t-flex-1">{t('YEAR')}</span>
      </div>
      <div className="t-flex t-gap-2.5">
        <select
          id="day"
          value={dayVal}
          onChange={(e) => handleValueChange(dayComp, 'day', e.target.value)}
          className="t-flex-1 t-py-3 t-px-3.5 t-pr-8 t-border-2 t-border-g200 t-rounded-xl t-font-sans t-text-sm t-text-navy t-bg-white t-outline-none focus:t-border-quiz-teal t-cursor-pointer t-appearance-none t-bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2712%27%20height%3D%278%27%20viewBox%3D%270%200%2012%208%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20d%3D%27M1%201.5L6%206.5L11%201.5%27%20stroke%3D%27%23BDBDBD%27%20stroke-width%3D%272%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%2F%3E%3C%2Fsvg%3E')] t-bg-no-repeat t-bg-[position:right_10px_center]"
        >
          <option value="">{'--'}</option>
          {days.map((d) => (
            <option key={d} value={d}>
              {d}
            </option>
          ))}
        </select>
        <select
          id="month"
          value={monthVal}
          onChange={(e) => handleValueChange(monthComp, 'month', e.target.value)}
          className="t-flex-1 t-py-3 t-px-3.5 t-pr-8 t-border-2 t-border-g200 t-rounded-xl t-font-sans t-text-sm t-text-navy t-bg-white t-outline-none focus:t-border-quiz-teal t-cursor-pointer t-appearance-none t-bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2712%27%20height%3D%278%27%20viewBox%3D%270%200%2012%208%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20d%3D%27M1%201.5L6%206.5L11%201.5%27%20stroke%3D%27%23BDBDBD%27%20stroke-width%3D%272%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%2F%3E%3C%2Fsvg%3E')] t-bg-no-repeat t-bg-[position:right_10px_center]"
        >
          <option value="">{'--'}</option>
          {months.map((m) => {
            const label = t(`Quiz_Month_${m}`);
            return (
              <option key={m} value={m}>
                {label}
              </option>
            );
          })}
        </select>
        <select
          id="year"
          value={yearVal}
          onChange={(e) => handleValueChange(yearComp, 'year', e.target.value)}
          className="t-flex-1 t-py-3 t-px-3.5 t-pr-8 t-border-2 t-border-g200 t-rounded-xl t-font-sans t-text-sm t-text-navy t-bg-white t-outline-none focus:t-border-quiz-teal t-cursor-pointer t-appearance-none t-bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2712%27%20height%3D%278%27%20viewBox%3D%270%200%2012%208%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20d%3D%27M1%201.5L6%206.5L11%201.5%27%20stroke%3D%27%23BDBDBD%27%20stroke-width%3D%272%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%2F%3E%3C%2Fsvg%3E')] t-bg-no-repeat t-bg-[position:right_10px_center]"
        >
          <option value="">{'--'}</option>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DobSelect;
